<script>
    import FrontPage from "./FrontPage.svelte";
    import Header from "./components/Header.svelte";
    import CarouselDemo from "./pages/CarouselDemo.svelte";
    import Footer from "./components/Footer.svelte";
    import ProductView from "./pages/ProductView.svelte";
    import About from "./pages/About.svelte";
    import Collections from "./pages/Collections.svelte";
    import Lotr from "./pages/Lotr.svelte";
    import { path } from "./router.js";

    $: page = $path === '/about'                  ? 'about'
            : $path === '/lotr'                   ? 'lotr'
            : $path.startsWith('/portfolio/')     ? 'product'
            : $path.startsWith('/collections/')   ? 'collection'
            : $path === '/collections'            ? 'collections'
            : 'home';

    $: productSlug = page === 'product'
        ? $path.slice('/portfolio/'.length)
        : null;

    $: collectionId = page === 'collection'
        ? $path.slice('/collections/'.length)
        : null;
</script>

<svelte:head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="author" content="Hanna Tiina Pekk" />

    <title>Hanna Tiina Pekk — Fashion Designer</title>
    <meta name="description" content="Portfolio of Hanna Tiina Pekk, fashion designer. Explore collections, bags, and wearable art." />

    <!-- Open Graph -->
    <meta property="og:type"        content="website" />
    <meta property="og:site_name"   content="Hanna Tiina Pekk" />
    <meta property="og:title"       content="Hanna Tiina Pekk — Fashion Designer" />
    <meta property="og:description" content="Portfolio of Hanna Tiina Pekk, fashion designer. Explore collections, bags, and wearable art." />

    <!-- Twitter / X -->
    <meta name="twitter:card"        content="summary_large_image" />
    <meta name="twitter:title"       content="Hanna Tiina Pekk — Fashion Designer" />
    <meta name="twitter:description" content="Portfolio of Hanna Tiina Pekk, fashion designer. Explore collections, bags, and wearable art." />

    <link rel="canonical" href="https://hannatiinapekk.com{$path}" />

    <link rel="icon" href="../icon.ico" type="image/x-icon" />

    <!-- JSON-LD: Person -->
    {@html `<script type="application/ld+json">${JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Person",
        "name": "Hanna Tiina Pekk",
        "jobTitle": "Fashion Designer",
        "url": "https://hannatiinapekk.com"
    })}</script>`}
</svelte:head>

<Header />

{#if page === 'lotr'}
    <Lotr />
{:else if page === 'product'}
    <ProductView slug={productSlug} />
{:else if page === 'about'}
    <About />
{:else if page === 'collection'}
    <Collections id={collectionId} />
{:else if page === 'collections'}
    <Collections />
{:else}
    <CarouselDemo />
    <FrontPage />
{/if}

<Footer />
